import {
    ReactElement,
    useRef,
} from 'react';

import {Stack,} from '@mantine/core';

import {
    MantineDataTable,
    SimpleTableBatchAction,
} from '@flexinet/ui-components';
import {usePersonasSelection} from '../hooks/usePersonasSelection';
import {usePersonas} from "../hooks/usePersonas.ts";
import {usePersonasSearch} from "../hooks/usePersonasSearch.ts";
import {usePersonasPaging} from "../hooks/usePersonasPaging.ts";
import {useAuth} from "../../../hooks/useAuth.ts";
import {useVerifiedPermissions} from "../../../hooks/useVerifiedPermissions.ts";
import {usePersonasTableColumns} from "../hooks/usePersonasTableColumns.tsx";
import {Persona, PersonaStatus} from "../types.ts";
import {DataTableColumn} from "mantine-datatable";
import {DataTableTokenPagination} from '../../../components/DataTableTokenPagination';
import {addToSelection} from '../reducers';
import {useAppDispatch} from '../../../hooks/useTypedReactRedux';


export const RecordsTable = ({
                                 statusFilter,
                                 extraTools,
                                 settings,
                             }: {
    statusFilter?: PersonaStatus | null,
    extraTools?: ReactElement[],
    settings?: { label: string, onClick: () => void }[]
}) => {

    const dispatch = useAppDispatch();

    const {
        user
    } = useAuth();


    if (!user) {
        throw new Error('user is required parameter')
    }

    const {allowedActions} = useVerifiedPermissions()


    const {
        visibleItems,
        visibleCount,
        nextToken,
        fetchRecords,
        isFetchingNextPage,
    } = usePersonas(statusFilter);

    const scrollViewportRef = useRef<HTMLDivElement>(null);

    const {
        columns,
    } = usePersonasTableColumns();

    const {
        handleFilterByKeyword,
    } = usePersonasSearch();

    const {
        limit,
        handleItemsPerPageChange,
    } = usePersonasPaging();


    const {
        selection,
        handleClearSelection,
    } = usePersonasSelection();


    let selectedRecords = [] as Persona[];
    if (allowedActions.includes('DeletePersona')) {
        selectedRecords = Object.keys(selection)
                                .map(key => selection[key])
    }


    return (
        <Stack gap={'lg'}>
            <SimpleTableBatchAction
                limit={limit}
                handleItemsPerPageChange={handleItemsPerPageChange}
                settings={settings}
                handleFilterByKeyword={handleFilterByKeyword}
                extraTools={extraTools}
            />

            <MantineDataTable
                columns={columns as DataTableColumn[]}
                records={visibleItems}
                selectedRecords={selectedRecords}
                onSelectedRecordsChange={(items) => {
                    handleClearSelection();
                    items.forEach(item => {
                        dispatch(addToSelection(item as unknown as Persona));
                    })
                }}
                fetching={false}
                onScrollToBottom={() => fetchRecords()}
                scrollViewportRef={scrollViewportRef}
                withTableBorder={true}
            />

            <DataTableTokenPagination
                totalCount={visibleCount.toString()}
                nextToken={nextToken}
                handleLoadMore={fetchRecords}
                loading={isFetchingNextPage}
            />

        </Stack>
    );
};